export default {"src":"/_next/static/media/booklinik-logo.63ed5d82.svg","height":26,"width":125};